// extracted by mini-css-extract-plugin
export default {"container":"regulations_container__HHNyh","wrapper":"regulations_wrapper__tk0a3","underline":"regulations_underline__1qD12"};